import { render, staticRenderFns } from "./PriceRules.vue?vue&type=template&id=09aef140&"
import script from "./PriceRules.vue?vue&type=script&lang=js&"
export * from "./PriceRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports